import { createRoot } from 'react-dom/client'
import { App } from './app'
import './index.css'

// StrictMode removed: React 19 double-mount breaks BlockNote's ProseMirror
// drag-and-drop internals (side menu event handlers register twice).
createRoot(document.getElementById('root')!).render(<App />)
